import { render, staticRenderFns } from "./pic_homeold.vue?vue&type=template&id=4ffb7e3a&scoped=true"
import script from "./pic_homeold.vue?vue&type=script&lang=js"
export * from "./pic_homeold.vue?vue&type=script&lang=js"
import style0 from "./pic_homeold.vue?vue&type=style&index=0&id=4ffb7e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffb7e3a",
  null
  
)

export default component.exports